module.exports = __webpack_public_path__ + "img/beratung-min.e162757a.jpg";